export const KitStatusLabels = {
  new: 'New',
  inboundShippingLabelPurchased: 'Inbound Shipping Label Purchased',
  unregisteredPrepaid: 'Unregistered Prepaid',
  outToPatient: 'Out To Patient',
  shippedByPatient: 'Shipped By Patient',
  deliveredToLab: 'Delivered To Lab',
  pendingConfirmation: 'Pending Confirmation',
  testComplete: 'Test Complete',
  manualReview: 'Manual Review',
  notifyComplete: 'Test Complete / Patient Notified',
  error: 'Error',
}
export const labTestResultLabels = [
  {
    value: 'none',
    label: 'pill-neutral',
  },
  {
    value: 'NSS',
    label: 'pill-success',
  },
  {
    value: 'Positive',
    label: 'pill-danger',
  },
  {
    value: 'error',
    label: 'pill-warning',
  },
]

export const labTestAdviceCodeChoices = [
  {
    value: 'acNotTested',
    label: 'acNotTested',
  },
  {
    value: 'acNSS',
    label: 'acNSS',
  },
  {
    value: 'acRetest4Week',
    label: 'acRetest4Week',
  },
  {
    value: 'acRetest6Week',
    label: 'acRetest6Week',
  },
  {
    value: 'acRetest8Week',
    label: 'acRetest8Week',
  },
  {
    value: 'acConsultProvider',
    label: 'acConsultProvider',
  },
  {
    value: 'acError',
    label: 'acError',
  },
  {
    value: 'acConsultProviderSpecial',
    label: 'acConsultProviderSpecial',
  },
]

export const labTestSampleGradeChoices = [
  {
    value: 'NONE',
    label: 'NONE (0/hpf)',
  },
  {
    value: 'RARE',
    label: 'RARE (<1/hpf)',
  },
  {
    value: 'MODERATE',
    label: 'MODERATE (~1-10)',
  },
  {
    value: 'HIGH',
    label: 'HIGH (10+/hpf)',
  },
  {
    value: 'ERROR',
    label: 'ERROR (specimen/test error)',
  },
  {
    value: 'FEW',
    label: 'FEW (~1-5/hpf) - deprecated; do not use',
  },
  {
    value: 'MANY',
    label: 'MANY (5-10/hpf) - deprecated; do not use',
  },
  {
    value: 'FAILEDVAS',
    label: 'FAILEDVAS - deprecated; do not use',
  },
]

export const labTestAdviceCodeDetail = [
  {
    value: 'acNotTested',
    use: 'Kit not tested',
    label: 'Sample not yet submitted/tested.',
  },
  {
    value: 'acNSS',
    use: 'NSS and 8+ weeks since DoV',
    label:
      'No sperm cells seen in sample. This is the expected result after a vasectomy, as it meets the American Urological Association recommendation for post-vasectomy clearance at the time of testing.',
  },
  {
    value: 'acRetest4Week',
    use: 'RARE',
    label:
      'RARE sperm seen in sample. Recommend to retest after at least another 4 weeks and 10 ejaculations. Clearance of sperm after vasectomy can take multiple months.',
  },
  {
    value: 'acRetest6Week',
    use: 'MODERATE and 8+ weeks since DoV ',
    label:
      'MODERATE sperm seen in sample. Recommend to retest after at least another 6 weeks and 15 ejaculations. Clearance of sperm after vasectomy can take multiple months. ',
  },
  {
    value: 'acRetest8Week',
    use: 'RARE, MODERATE, or HIGH and < 8 weeks since DoV ',
    label:
      'RARE/MODERATE/HIGH sperm seen in sample, less than 8 weeks since vasectomy. Recommend to retest after at least another 8 weeks and 20 ejaculations. Clearance of sperm after vasectomy can take multiple months.',
  },
  {
    value: 'acConsultProvider',
    use: 'HIGH and 8+ weeks since DOV',
    label: 'MODERATE/HIGH sperm seen in sample. Please contact your physician to discuss this result.',
  },
  {
    value: 'acConsultProviderSpecial',
    use: 'Manually select this option for other abnormal results, where patient should contact provider. Please enter specific instructions in provider notes field.',
    label: 'Please contact your physician to discuss this result.',
  },
  {
    value: 'acError',
    use: 'Testing error',
    label: 'An error occurred with the sample. Contact support for assistance.',
  },
]

const CONFIG = {
  dev: {
    storeURL: 'https://dev-malefromhome.myshopify.com',
    storeURLLabel: 'dev-malefromhome.myshopify.com',
    providerEnrollment: 'https://dev-malefromhome.myshopify.com/pages/provider-enrollment',
    mfhAccount: 'https://dev-malefromhome.myshopify.com/pages/provider-tools',
    patientBrochures: 'https://dev-malefromhome.myshopify.com/pages/providers',
    bulkSpecimenKits: 'https://dev-malefromhome.myshopify.com/collections/vasectomy-testing-kits',
  },
  test: {
    storeURL: 'https://dev-malefromhome.myshopify.com',
    storeURLLabel: 'dev-malefromhome.myshopify.com',
    providerEnrollment: 'https://dev-malefromhome.myshopify.com/pages/provider-enrollment',
    mfhAccount: 'https://dev-malefromhome.myshopify.com/pages/provider-tools',
    patientBrochures: 'https://dev-malefromhome.myshopify.com/pages/providers',
    bulkSpecimenKits: 'https://dev-malefromhome.myshopify.com/collections/vasectomy-testing-kits',
  },
  prod: {
    storeURL: 'https://malefromhome.com',
    storeURLLabel: 'www.malefromhome.com',
    providerEnrollment: 'https://malefromhome.com/pages/provider-enrollment',
    mfhAccount: 'https://malefromhome.com/pages/provider-tools',
    patientBrochures: 'https://malefromhome.com/collections/providers/products/malefromhome-patient-brochures',
    bulkSpecimenKits: 'https://malefromhome.com/products/bulk-specimen-kits-10?variant=32062723293220',
  },
}

// Determine current environment context (defaults to 'development' if not set)
const env = process.env.REACT_APP_ENV || 'dev'

export const ENV_BASED_CONSTANTS = CONFIG[env]